var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.checkedCategories.length
    ? _c(
        "ul",
        { staticClass: "list-selected" },
        _vm._l(_vm.checkedCategories, function(category) {
          return _c("li", [
            _vm._v(
              "\n        " +
                _vm._s(_vm.resolveCategoryName(category)) +
                "\n        "
            ),
            _c(
              "a",
              {
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.$emit("remove-category", category.id)
                  }
                }
              },
              [_vm._v("usuń")]
            )
          ])
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }